import { render } from "./Mitra.vue?vue&type=template&id=1567f7f0&scoped=true"
import script from "./Mitra.vue?vue&type=script&lang=js"
export * from "./Mitra.vue?vue&type=script&lang=js"

import "./Mitra.vue?vue&type=style&index=0&id=1567f7f0&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1567f7f0"]])

export default __exports__